import { FC } from 'react'
import { Radio } from '@pepper/ui'
import { useHistory } from 'react-router-dom'

import {
  BooleanParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import s from './Sort.module.css'

export const Sort: FC = () => {
  const history = useHistory()
  const [query, setQuery] = useQueryParams({
    sort: withDefault(StringParam, undefined),
    content_ideas: withDefault(BooleanParam, false),
  })

  const isSuggestionsSort =
    history.location.pathname === '/content-ideas' || query.content_ideas

  return (
    <div className={s.wrapper}>
      <div className={s.title}>Sort By</div>
      <Radio
        value="volume"
        checked={
          query.sort === 'volume:desc' || (isSuggestionsSort && !query.sort)
        }
        onChange={() => {
          setQuery({
            sort: 'volume:desc',
          })
        }}
      >
        Volume
      </Radio>
      <Radio
        value="difficulty"
        checked={query.sort === 'difficulty:asc'}
        onChange={() =>
          setQuery({
            sort: 'difficulty:asc',
          })
        }
      >
        Difficulty
      </Radio>
      <Radio
        value="intent"
        checked={query.sort === 'intent:desc'}
        onChange={() =>
          setQuery({
            sort: 'intent:desc',
          })
        }
      >
        Intent
      </Radio>
      {!isSuggestionsSort && (
        <Radio
          value="none"
          checked={!query.sort}
          defaultChecked={true}
          onChange={() =>
            setQuery({
              sort: undefined,
            })
          }
        >
          Latest Added
        </Radio>
      )}
    </div>
  )
}
